import { render, staticRenderFns } from "./packaging-bjp.vue?vue&type=template&id=096d0ffa"
import script from "./packaging-bjp.vue?vue&type=script&lang=js"
export * from "./packaging-bjp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports